export const GET_ALL_MEMBERSHIP_PLAN = "GET_ALL_MEMBERSHIP_PLAN";
export const GET_PLANS_BY_PLAN_ID = "GET_PLANS_BY_PLAN_ID";
export const MEMBERSHIP_LOADING = "MEMBERSHIP_LOADING";
export const MEMBERSHIP_LOADED = "MEMBERSHIP_LOADED";